import React from 'react';
import { Outlet } from 'react-router-dom';
const AuthPageLayout = () => {
    return (
        <>
            <div data-testid="full-width-centered-layout"> <Outlet /></div>
        </>
    );
};
export default AuthPageLayout;
